import React, { useState } from 'react'
import { ExclamationCircleIcon } from '@heroicons/react/outline'
import IngredientsTab from '../Learn/IngredientsTab'

export default function TagIcons({
    fodMapWarning = 2,
    allergenWarning,
    vegetarian,
    vegan,
    allergenDialog,
    glutenFree,
    sugarFree,
    dairyFree

}) {
    const fodColour = fodMapWarning < 2 ? 'text-an_green-dark' : fodMapWarning < 3  ? 'text-an_orange' : 'text-an_orange-darker1' 

    return (
        <div className="flex justify-center">
            { 
                allergenWarning && 
                    <div className="mr-1 mt-[-6px] hover:bg-an_green-dark rounded hover:text-an_white p-1" onClick={allergenDialog}>
                        <ExclamationCircleIcon className="h-6 w-6 mx-auto block text-an_orange-dark"/>
                        <small className="text-[6px] block text-center mt-[-3px] text-an_orange-dark">allergens</small>
                    </div> 
            }
            {
                <div className={`mr-1 mt-[-6px] hover:bg-an_green-dark rounded hover:text-an_white p-1 ${fodColour}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6 mx-auto">
                        <path fill-rule="evenodd" d="M12 2.25a.75.75 0 0 1 .75.75v.756a49.106 49.106 0 0 1 9.152 1 .75.75 0 0 1-.152 1.485h-1.918l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 18.75 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84l2.474-10.124H12.75v13.28c1.293.076 2.534.343 3.697.776a.75.75 0 0 1-.262 1.453h-8.37a.75.75 0 0 1-.262-1.453c1.162-.433 2.404-.7 3.697-.775V6.24H6.332l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 5.25 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84L4.168 6.241H2.25a.75.75 0 0 1-.152-1.485 49.105 49.105 0 0 1 9.152-1V3a.75.75 0 0 1 .75-.75Zm4.878 13.543 1.872-7.662 1.872 7.662h-3.744Zm-9.756 0L5.25 8.131l-1.872 7.662h3.744Z" clip-rule="evenodd" />
                    </svg>
                    <small className="text-[6px] block text-center mt-[-3px]">fod rating: {fodMapWarning}</small>
                </div> 
            }
            { 
                vegetarian && !vegan && 
                    <span className="border border-an_green-dark py-1 mr-2 text-an_green-dark text-xs w-6 h-6 text-center rounded-full">V</span> 
            }
            { 
                vegan && 
                    <span className="border border-an_green-dark py-1 mr-2 text-an_green-dark text-xs w-6 h-6 text-center rounded-full">VG</span> 
            }
            { 
                dairyFree && 
                    <span className="border border-an_green-dark py-1 mr-2 text-an_green-dark text-xs w-6 h-6 text-center rounded-full">DF</span> 
            }
            { 
                glutenFree && 
                    <span className="border border-an_green-dark py-1 mr-2 text-an_green-dark text-xs w-6 h-6 text-center rounded-full">GF</span> 
            }
            { 
                sugarFree && 
                    <span className="border border-an_green-dark py-1 text-an_green-dark text-xs w-6 h-6 text-center rounded-full">SF</span> 
            }
        </div>
    )
}